export const parseCellIdentity = (identity: string): [number, number] => {
  const parts = identity.split(':');
  return [Number(parts[0]) - 1, Number(parts[1]) - 1];
};

export const stringifyCellIdentity = (row: number, column: number) =>
  `${row + 1}:${column + 1}`;
